/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { CSV_EXPORT_PATH, withApiQuery } from "../../../utils/reportExport";

/**
 * Where the Group Sales Summary is downloaded from, in either format.
 *
 * PDF and CSV are built from the same server-side document builder, so the two formats and the
 * table on screen can never disagree about a number. Only the URLs differ, which is all this
 * module holds — the download machinery itself is shared in utils/reportExport.
 *
 * Group level only this phase; the per-restaurant drill-in export ships with the
 * revenue-center grain.
 */
export const buildGroupExportUrl = ({ format, businessDate, scope = {} }) =>
  format === "csv"
    ? withApiQuery(CSV_EXPORT_PATH, {
        report: "daily_sales_report",
        business_date: businessDate,
        ...scope,
      })
    : withApiQuery("/v1/admin/daily_sales_reports/export", {
        business_date: businessDate,
        ...scope,
      });

/**
 * Fallback name, used only when a response carries no Content-Disposition. Both endpoints name
 * their own file, and the PDF names itself after its masthead title, which the client does not
 * have — so this is the date the manager sorts by and nothing more.
 */
export const exportFilename = ({ format, businessDate }) => {
  const date = businessDate ? `-${businessDate}` : "";

  return `daily-sales${date}.${format}`;
};
